const usuario = angular.module('usuario', [])

usuario.config(['$stateProvider', function($stateProvider) {

    const routes = [
        {
            name: 'cliente.usuario',
            url: '/usuario',
            params: { showGlobalLoading: { dynamic: true, value: true }},
            component: 'usuario.usuarioComponent'
        }
    ];

    routes.forEach($stateProvider.state);
}]);